import BaseApi from './base';

class Vehicle extends BaseApi {
    endpoint = 'vehicles';
}

export default new Vehicle();




// WEBPACK FOOTER //
// ./src/psuite-js/apis/delivery/vehicle.js